import { FC, useRef } from 'react'
import styles from './PersonalStewardScroll.module.scss'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'
import { ImgBackground, Source } from 'components/basic/Img'

interface PersonalStewardScrollProps {
	mainTitle?: string
	fadeinTitle?: string
	images?: Source[]
}

const assets: Source[] = [
	{
		src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/personal-steward-autopilot-mobile.jpg',
		mediaQuery: '(max-width: 599px)',
		dprHeight: 1080,
	},
	{
		src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/personal-steward-autopilot-desktop.jpg',
		mediaQuery: '(min-width: 600px)',
		dprHeight: 1080,
	},
]

export const PersonalStewardScroll: FC<PersonalStewardScrollProps> = (props) => {
	const mainRef = useRef(null)
	const animatedRef1 = useRef(null)
	const animatedRef2 = useRef(null)

	const { images, mainTitle = 'Autopilot is your personal sleep steward.', fadeinTitle = 'It adjusts your environment to perfect your sleep experience.' } = props

	useGSAP(() => {
		gsap.registerPlugin(ScrollTrigger)
		ScrollTrigger.create({
			trigger: mainRef.current,
			animation: gsap.to(animatedRef1.current, {
				opacity: 0.2,
				duration: 3,
				translateY: 0,
			}),
			start: 'top center',
			end: 'top 100px',
			pin: false,
			markers: false,
			scrub: true,
		})
		ScrollTrigger.create({
			trigger: mainRef.current,
			animation: gsap.to(animatedRef2.current, {
				opacity: 1,
				duration: 3,
				scale: 1,
				translateY: 0,
			}),
			start: 'top center',
			end: 'top 100px',
			pin: false,
			markers: false,
			scrub: true,
		})
	})

	return (
		<section className={`${styles.container}`}>
			<ImgBackground
				className={`${styles.simple_article}`}
				dprHeight={1080}
				sources={images ?? assets}
				src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/personal-steward-autopilot-mobile.jpg"
				alt="Someone resting on bed with a book"
			>
				<div ref={mainRef}></div>
				<p
					className={styles.initial_text}
					ref={animatedRef1}
				>
					{mainTitle}
				</p>
				<p
					className={styles.fadein_text}
					ref={animatedRef2}
				>
					{fadeinTitle}
				</p>
			</ImgBackground>
		</section>
	)
}
